import angular from 'angular';
import { Notification } from './model/notification';
import SignalRService from '@/shared/services/SignalRService';
import moment from 'moment';
import { services } from 'angular-ui-router';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cxNotifications')
  .factory('notificationSvc', [
    '$state',
    '$q',
    '$http',
    '$rootScope',
    '$filter',
    'appUrls',
    'dataCache',
    '$translate',
    'resourceFactorySvc',
    'dialogsSvc',
    '$timeout',
    'flySvc',
    notificationSvc,
  ]);

function notificationSvc(
  $state,
  $q,
  $http,
  $rootScope,
  $filter,
  appUrls,
  dataCache,
  $translate,
  resourceFactorySvc,
  dialogsSvc,
  $timeout,
  flySvc,
) {
  const service = {
    notifications: [],
    barVisible: false,
    taskId: null,
  };

  service.countUnseen = function() {
    return service.notifications.reduce(function(cnt, el) {
      return cnt + (el.unread ? 1 : 0);
    }, 0);
  };

  function combineNotifications(notifications) {
    service.notifications.clear();

    if (!notifications || !notifications.length) return;

    service.notifications = $.map(
      notifications.reduce(function(o, e, index) {
        if (e.json && typeof e.json === 'string') {
          try {
            const json = JSON.parse(e.json);
            e = {
              ...e,
              ...json,
            };
          } catch (error) {
            console.error(error);
          }
        }

        // dont group custom messages, connect info messages, because their content is different even tho they are the same type
        var combineNotification =
          e.type !== 500 &&
          e.type !== 900 &&
          e.type !== 901 &&
          e.type !== 1000 &&
          e.type !== 1001 &&
          e.type !== 1002;
        if (combineNotification) {
          if (!o[e.type]) {
            var notification = new Notification(e);
            if (notification.type === 400) {
              addTrialExpireDays(notification);
            }
            o[e.type] = notification;
          } else {
            o[e.type].add(e);
            if (e.createDate > o[e.type].createDate) o[e.type].createDate = e.createDate;
          }
        } else {
          var notification = new Notification(e);
          o[`${e.type}-${index}`] = notification;
        }

        return o;
      }, {}),
      function(value) {
        return value;
      },
    );
    service.notifications.sortByProperty('-createDate');
  }

  function reloadNotifications() {
    $http.get(appUrls.notifications + '/Api/Notifications/').then(function(response) {
      combineNotifications(response.data);
    });
  }

  function addTrialExpireDays(notification) {
    dataCache.ready().then(function() {
      var trialDate = dataCache.getArray('trialExpiryDate');
      if (typeof trialDate === 'string') trialDate = new moment(trialDate).toDate();

      var days = Math.floor(
        (trialDate -
          moment
            .utc()
            .startOf('day')
            .toDate()) /
          86400000,
      );
      notification.param = days;
    });
  }

  function addJobParams(notification) {
    if ($translate.isReady()) setJobParams(notification);
    else $translate.onReady(() => setJobParams(notification));
  }

  function setJobParams(notification) {
    var jobParams = JSON.parse(notification.json);

    if (jobParams.jobType || jobParams.jobType === 0) {
      var jobType = $filter('translateList')(jobParams.jobType, 'jobtype');
      notification.jobType = jobType;
    }
    if (jobParams.jobStatus || jobParams.jobType === 0) {
      var jobStatus = $filter('translateList')(jobParams.jobStatus, 'jobstatus');
      notification.jobStatus = jobStatus;
    }
  }

  service.markSeen = function(notification) {
    if (!notification) return;

    var notificationIds =
      notification.items && notification.items.length > 1
        ? notification.items.map(x => x.id)
        : [notification.id];

    if (!notification.unread) return;

    $http
      .post(appUrls.notifications + '/Api/Notifications/MarkSeen', notificationIds)
      .then(function(response) {
        var result = response.data;
        notification.unread = false;
        if (notification.items && notification.items.length > 0) {
          notification.items.forEach(function(notification) {
            notification.unread = false;
          });
        } else {
          findAndUpdateNotification(notification);
        }
      })
      .catch(function(error) {});
  };

  service.markAllSeen = function() {
    if (!service.notifications || service.notifications.length < 1) return;

    var notificationIds = [];

    service.notifications.forEach(function(notification) {
      notification.items.forEach(function(item) {
        notificationIds.push(item.id);
      });
    });

    $http
      .post(appUrls.notifications + '/Api/Notifications/MarkSeen', notificationIds)
      .then(function(response) {
        var result = response.data;
        service.notifications.forEach(function(notification) {
          notification.unread = false;
          notification.items.forEach(function(item) {
            item.unread = false;
          });
        });
      })
      .catch(function(error) {});
  };

  service.markExpired = function(notification) {
    if (!notification || !notification.items || notification.items.length < 1) return;
    var notificationIds = notification.items.map(x => x.id);
    $http
      .post(appUrls.notifications + '/Api/Notifications/Expire', notificationIds)
      .then(function(response) {
        var result = response.data;
        var idx = service.notifications.findIndex(function(el) {
          return el.id === notification.id;
        });
        if (idx >= 0) service.notifications.splice(idx, 1);
      })
      .catch(function(error) {});
  };

  function openTaskDetailDialog(taskId) {
    service.taskId = { id: taskId };
  }

  service.doAction = function(item) {
    service.hideNotifications();
    service.markSeen(item);
    console.log(item);
    switch (item.type) {
      case 100:
        return $state.go('invoicing.draft');
      case 103:
        return $state.go('invoicing.overview');
      case 104:
        if (item.items && item.items.length === 1) {
          item = item.items[0];
        }
        const linkType = item.linkType || item.LinkType; // backwards compatbility for json serialization issue not respecting camelCase
        if (linkType === 0 || linkType === 1) {
          // send email failed: depending on the email link type, navigate to the correct screen
          return $state.go('invoicing.overview', {
            invoiceId: item.objectId,
          });
        }
        if (linkType === 2) {
          return $state.go('taskflow.taskboard', {
            relation: item.relation,
          });
        }
        if (linkType === 4) {
          return $state.go('interactions', {
            relationId: item.objectId,
          });
        }
        break;
      case 204:
        return $state.go('relations.import');
      case 200:
      case 201:
      case 202:
      case 203:
      case 205:
      case 206:
      case 207:
      case 208:
      case 209:
      case 210:
      case 211:
      case 212:
      case 213:
      case 214:
      case 215:
      case 216:
      case 217:
      case 218:
      case 219:
      case 221:
      case 222:
        return $state.go('relations.detail', {
          relId: item.objectId,
        });
      case 400: //Tenant expiring
        return $state.go('settings.license');
      //Custom URL
      case 500:
        if (item.redirectUrl) window.location = item.redirectUrl;
        break;
      case 501:
        if (item.info.taskId) openTaskDetailDialog(item.info.taskId);
        break;
      case 600:
        return $state.go('settings.license');
      case 700:
        return $state.go('jobs.detail', {
          jobId: item.objectId,
        });
      case 800:
        return $state.go('documents', {
          documentId: item.objectId,
        });
      case 801:
        DocumentService.download(item.objectId);
        break;
      case 900:
      case 901:
        const connectUrl = `${appUrls.connect}/home/notification?companyId=${item.companyId}&connectPlatform=${item.connectPlatformInt}`;
        window.open(connectUrl, '_blank');
      case 1000:
      case 1001:
      case 1002:
      case 1003:
      case 1004:
        const url = item.shareUrl;
        if (url) {
          window.open(url, '_blank');
        }
        break;
      case 1100:
      case 1101:
      case 1102:
        return $state.go('accessTokens');
      case 1200:
        return $state.go('employees.detail', { id: item.objectId });
      default:
        if (item.type >= 200 && item.type < 300) {
          return $state.go('relations.detail', {
            relId: item.objectId,
          });
        }
        service.showNotifications();

        return undefined;
    }
  };
  service.getTooltip = function() {
    if (!service.notifications.length) return '';
    var nr = service.countUnseen();
    if (nr === 1) return $translate.instant('1 new notification');
    if (nr > 1)
      return $translate.instant('{nr} new notifications', {
        nr: nr,
      });

    nr = service.notifications.length;
    if (nr === 1) return $translate.instant('1 notification');
    if (nr > 1)
      return $translate.instant('{nr} notifications', {
        nr: nr,
      });
    return '';
  };

  service.disableNotificationType = function(item) {
    if (!item) return;
    return dialogsSvc
      .showYesNoCancel('comfirmDisableNotificationType', 'msgConfirmDeleteNotificationsOfType')
      .then(
        function(result) {
          if (result === null) return false; // Cancel changes

          const requests = [
            $http.put(appUrls.notifications + '/Api/Settings/Type', {
              type: item.type,
              shouldCreate: false,
            }),
          ];

          if (result) {
            requests.push(service.markExpired(item));
          }
          return $q.all(requests).then(() => {
            flySvc.success('msgConfirmChange');
            return true;
          });
        },
        function() {
          return false; // Cancel changes
        },
      );
  };

  /*Toggle bar visibility */
  service.showNotifications = function() {
    service.barVisible = true;
  };
  service.hideNotifications = function() {
    service.barVisible = false;
  };
  service.toggleNotifications = function() {
    service.barVisible = !service.barVisible;
  };
  service.getTaskDetailId = function() {
    return service.taskId;
  };
  service.closeTaskDetail = function() {
    $timeout(() => {
      service.taskId = null;
    }, 0);
  };

  reloadNotifications();

  var addNotification = function(notification) {
    var notif = service.notifications.find(function(el) {
      return el.type === notification.type;
    });
    if (!notif) {
      service.notifications.unshift(new Notification(notification));
    } else {
      notif.add(notification);
    }
  };
  var findAndUpdateNotification = function(notification) {
    var idx = service.notifications.findIndex(function(el) {
      return el.type === notification.type;
    });
    if (idx >= 0) {
      service.notifications[idx].update(notification);
      if (service.notifications[idx].cnt === 0) service.notifications.splice(idx, 1);
    }
  };
  var findAndRemoveNotification = function(notification) {
    var idx = service.notifications.findIndex(function(el) {
      return el.type === notification.type;
    });
    if (idx >= 0) {
      service.notifications[idx].remove(notification);
      if (service.notifications[idx].cnt === 0) service.notifications.splice(idx, 1);
    }
  };

  const createNotificationHandler = function(actionFunc) {
    return function(notifications) {
      if (!notifications) return;
      if (typeof notifications === 'string' && notifications.indexOf('[') === 0)
        notifications = JSON.parse(notifications);
      if (angular.isArray(notifications)) {
        for (var i = 0; i < notifications.length; i++) actionFunc(notifications[i]);
      } else {
        //One object
        actionFunc(notifications);
      }
    };
  };

  SignalRService.subscribe('addNotifications', createNotificationHandler(addNotification));
  SignalRService.subscribe(
    'updateNotifications',
    createNotificationHandler(findAndUpdateNotification),
  );
  SignalRService.subscribe(
    'removeNotifications',
    createNotificationHandler(findAndRemoveNotification),
  );

  return service;
}
